import HTTP from '@/utils/http'
class CourseModel extends HTTP {
    /**
    * @description 查询下级节点
    * @see https://yapi.dayuan1997.com/project/71/interface/api/4796
    */
    getNode(params) {
        return this.get({
            url: `/course/list`,
            params
        })
    }

    /**
    * @description 查询获取模版配置
    * @see https://yapi.dayuan1997.com/project/25/interface/api/8311
    */
    getTemplateValue(params) {
        return this.get({
            url: `/cmscore/template/data`,
            params
        })
    }
}

export default CourseModel